import JSZip from "jszip";

import { normalizeCropCode } from "pages/admin/experiments/cropExtraction/cropCodes";
import { directChildElements, findXmlInZip, findYearInXml, parseXml, xmlNumber, xmlText } from "pages/admin/experiments/cropExtraction/parsers/xmlHelpers";
import { CropRecord, ParserResult } from "pages/admin/experiments/cropExtraction/types";

export const parseDataExperts = async (jszip: JSZip): Promise<ParserResult> => {
  const warnings: string[] = [];
  const found = await findXmlInZip(jszip, (rel) => rel.toLowerCase().endsWith(".nn.xml"));
  if (!found) return { method: "xml_parsing", crops: [], warnings: ["Could not find *.nn.xml file"] };

  const { doc, error } = parseXml(found.xml);
  if (error) return { method: "xml_parsing", crops: [], warnings: [`XML parser error: ${error}`] };

  const crops: CropRecord[] = [];
  const gesamtparzellen = Array.from(doc.getElementsByTagNameNS("*", "gesamtparzelle"));

  for (const gp of gesamtparzellen) {
    const fieldName = xmlText(gp, "parzellenname") || xmlText(gp, "bezeichnung");
    const fieldNumber = xmlText(gp, "gp_nummer") || xmlText(gp, "schlagnr") || xmlText(gp, "schlagnummer");

    // hauptnutzungsflaeche entries can sit either directly under <gesamtparzelle>
    // or nested inside <teilflaechen> children. Walk both layouts.
    const teilflaechenContainers = directChildElements(gp, "teilflaechen");
    const hauptnutzungen =
      teilflaechenContainers.length === 0
        ? Array.from(gp.getElementsByTagNameNS("*", "hauptnutzungsflaeche"))
        : teilflaechenContainers.flatMap((tf) => Array.from(tf.getElementsByTagNameNS("*", "hauptnutzungsflaeche")));

    if (hauptnutzungen.length === 0) {
      warnings.push(`Field ${fieldName || fieldNumber || "?"} has no hauptnutzungsflaeche`);
    } else {
      for (const hnf of hauptnutzungen) {
        const teilflaechennummer = xmlText(hnf, "teilflaechennummer");
        const groesseM2 = xmlNumber(hnf, "groesse");
        crops.push({
          fieldId: teilflaechennummer || `${fieldNumber}.01`,
          fieldName: fieldName || teilflaechennummer || fieldNumber || "",
          cropCode: normalizeCropCode(xmlText(hnf, "nutzung")),
          cropDescription: "",
          areaHa: groesseM2 > 0 ? groesseM2 / 10000 : 0,
          fieldNumber: fieldNumber || undefined,
        });
      }
    }
  }

  if (crops.length === 0) warnings.push("No <gesamtparzelle> entries with crop codes were found");
  return { method: "xml_parsing", crops, warnings, year: findYearInXml(doc) };
};
